import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Removes focused variable holder after applying variable values.
 */
export const removeFocusedAfterApply = store.effects.create(
  (feature: Feature) =>
    feature.actions.applyValuesFor
      .observe()
      .pipe(
        rxjs.map(action =>
          feature.actions.removeFocused
            .from('removeFocusedAfterApply (effect)')
            .create(),
        ),
      ),
)
